import React, {useCallback, useMemo} from 'react';
import {ButtonOverlay} from '@homeaway/react-buttons';
import edapWrapper from '@homeaway/edap-wrapper';
import './Banner.less';
import desktopBanner from './desktop-image.png';
import mobileBanner from './mobile-image.png';

export const FAMILY_COLLECTION_FILTER_ID = 'filter:10133';

export default function Banner({triggerFilter, isMobile, translations}) {
    const handleClick = useCallback(() => {
        triggerFilter(FAMILY_COLLECTION_FILTER_ID);
        edapWrapper().push({
            name: 'generic.click',
            data: {
                eventaction: 'family_collection_serp_ad',
                eventcategory: 'serpbanner',
                actionlocation: 'serp',
            },
        });
    }, [triggerFilter]);

    return (
        <div className="FamilyCollectionBanner">
            <div className="FamilyCollectionBanner__Content">
                <h2 className="FamilyCollectionBanner__Header">
                    {translations['family.collection.banner.title']}
                </h2>
                <p className="FamilyCollectionBanner__text">
                    {translations['family.collection.banner.body']}
                </p>
                <BannerImage
                    isMobile={isMobile}
                    onClick={handleClick}
                    translations={translations}
                />
            </div>
        </div>
    );
}

function BannerImage({isMobile, onClick, translations}) {
    const imageSource = useMemo(() => {
        const image = isMobile ? mobileBanner : desktopBanner;

        // The storybook and test harness build processes seem to differ in how they import the image
        // One gives a function, one gives a string
        // I'm not what the published build will do
        // Unit tests don't import anything, but we solve that with proxyquire in the unit tests

        /* istanbul ignore else */
        if (typeof image === 'string') {
            return image;
        }

        /* istanbul ignore next */
        return image();
    }, [isMobile]);

    return (
        <div
            className="FamilyCollectionBanner__Image"
            style={{
                backgroundSize: 'cover',
                backgroundImage: `url(${imageSource})`,
            }}
            onClick={onClick}
        >
            <ButtonOverlay
                label={translations['family.collection.banner.button']}
                size="lg"
            />
        </div>
    );
}
